import { createContext, useContext } from "react";

function parseTableEnvironment(tableNode, state) {
    const tableEnvironment = {
        table: { from: tableNode.from, to: tableNode.to },
        footnotes: [],
    };

    function walk(node) {
        if (node.type.is("Caption")) {
            const argumentNode = node.getChild("TextArgument")?.getChild("LongArg");
            tableEnvironment.caption = {
                from: node.from,
                to: node.to,
                content: argumentNode ? { from: argumentNode.from, to: argumentNode.to } : undefined,
            };
        }

        if (node.type.is("Label")) {
            const argumentNode = node.getChild("LabelArgument")?.getChild("ShortTextArgument")?.getChild("ShortArg");
            tableEnvironment.label = {
                from: node.from,
                to: node.to,
                content: argumentNode ? { from: argumentNode.from, to: argumentNode.to } : undefined,
            };
        }

        if (node.type.is("UnknownCommand")) {
            const commandNameNode = node.getChild("$CtrlSeq");
            const commandName = commandNameNode ? state.sliceDoc(commandNameNode.from, commandNameNode.to).trim() : "";
            if (commandName === "\\footnotetext") {
                const optionalNode = node.getChild("OptionalArgument")?.getChild("ShortOptionalArg");
                const textNode = node.getChild("TextArgument")?.getChild("LongArg");
                tableEnvironment.footnotes.push({
                    from: node.from,
                    to: node.to,
                    marker: optionalNode
                        ? {
                              from: optionalNode.from,
                              to: optionalNode.to,
                          }
                        : undefined,
                    content: textNode
                        ? {
                              from: textNode.from,
                              to: textNode.to,
                          }
                        : undefined,
                });
            }
        }

        for (let child = node.firstChild; child; child = child.nextSibling) {
            walk(child);
        }
    }

    walk(tableNode);

    return tableEnvironment;
}

const TableContext = createContext(undefined);

export function TableProvider({ tableData, tableNode, tabularNode, directTableChild, view, children }) {
    const positions = {
        cells: tableData.cellPositions,
        columnDeclarations: tableData.specification,
        rowPositions: tableData.rowPositions,
        tabular: { from: tabularNode.from, to: tabularNode.to },
    };

    return (
        <TableContext.Provider
            value={{
                ...tableData,
                positions,
                tableEnvironment: tableNode ? parseTableEnvironment(tableNode, view.state) : undefined,
                rows: tableData.table.rows.length,
                columns: tableData.table.columns.length,
                directTableChild,
            }}
        >
            {children}
        </TableContext.Provider>
    );
}

export function useTableContext() {
    const context = useContext(TableContext);
    if (context === undefined) {
        throw new Error("useTableContext must be used within a TableProvider");
    }
    return context;
}
